import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';

export class DashboardService {
	private baseUrl = environment.apiGateway.apiUrl;
	private dashboardApiUrl = '';

	constructor() {
		this.dashboardApiUrl = this.baseUrl + 'Dashboard/';
	}

	/**
	 *  get user own record
	 */
	public async getDashboard(pageToken?: string, pageSize?: number, day?: number, endDate?: Date, cancelToken?: CancelToken): Promise<models.IDashboard> {
		try {
			const res = await axios.get<models.IDashboard>(this.dashboardApiUrl, {
				cancelToken,
				params: {
					day,
					endDate,
					pageToken,
					pageSize
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/dashboard.service.ts